import type { AccountingPostingValidationErrorData } from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";
import { type FormAction } from "src/components/Form/Form.types.ts";
import { AccountingPostingValidationErrorImpl } from "src/components/Form/components/AccountingPostingValidationErrorImpl/AccountingPostingValidationErrorImpl.tsx";

export const AccountingPostingValidationError = (props: {
  data: AccountingPostingValidationErrorData;
  type: FormAction;
}) => {
  return <AccountingPostingValidationErrorImpl {...props} />;
};
